<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search_data"
            :loading="$store.state.settings.loading.sites"
            loadingText="Seiten werden geladen. Das kann eine Weile dauern..."
            no-data-text="Keine Daten"
            class="pointer"
            no-results-text="Keine Ergebnisse"
            @click:row="openDialog($event)"
        >
            <template v-slot:progress>
                <v-progress-linear indeterminate :color="ada.pink" class="d-flex" height="3"></v-progress-linear>
            </template>
            <template v-slot:top>
                <div class="d-flex align-center justify-space-between mx-4">
                    <div class="d-flex align-center flex-row">
                        <div class="pr-6 text-h6 font-weight-regular">Seiten</div>
                        <v-text-field
                            v-model="search_data"
                            label="Suchen..."
                            append-icon="mdi-magnify"
                            class="mx-4 pt-5"
                            :color="ada.blue"
                            :style="{width: $vuetify.breakpoint.mdAndUp ? '300px' : '200px'}"
                        ></v-text-field>
                    </div>
                    <div>
                        <Button v-if="$vuetify.breakpoint.mdAndUp" icon="mdi-plus"
                                @click="openDialog(null, 'add')"
                                :color="ada.blue">Seite hinzufügen
                        </Button>
                    </div>
                </div>
            </template>
            <template #[`item.action`]="{ item }">
                <v-tooltip top v-for="(action, i) in item.action" :key="'action_'+i">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="actionIcon"
                            :data-type="action" :color="ada.grey"
                            @click.stop="openDialog(item, action)">
                            {{ getAction(action).icon }}
                        </v-icon>
                    </template>
                    <span>{{ getAction(action).tooltip }}</span>
                </v-tooltip>

            </template>
            <template #[col.name]="{item}"
                      v-for="col in [
                          {name:'item.IsDisplay', value:'IsDisplay'},
                          {name:'item.IsVideo', value:'IsVideo'},
                          {name:'item.UsesAdaBundle', value:'UsesAdaBundle'}]">
                <v-icon :color="item[col.value] === 1 ? 'green' : (col.value === 'UsesAdaBundle' ? 'red' : ada.grey) "
                        :key="col.value">
                    {{ item[col.value] === 1 ? 'mdi-check' : 'mdi-close' }}
                </v-icon>
            </template>
        </v-data-table>
        <AddSiteDialog v-model="showSiteDialog"></AddSiteDialog>
        <EditSiteDialog v-model="showEditSiteDialog"></EditSiteDialog>
        <CopySiteDialog v-model="showCopySiteDialog"></CopySiteDialog>
        <DeleteSiteDialog v-model="showDeleteSiteDialog"></DeleteSiteDialog>
    </div>
</template>

<script>
import ada from '@/scss/ada_colors.scss'
import Button from "../../../components/buttons/Button";
import AddSiteDialog from "../Dialogs/AddSiteDialog";
import EditSiteDialog from "../Dialogs/EditSiteDialog";
import CopySiteDialog from "../Dialogs/CopySiteDialog";
import DeleteSiteDialog from "../Dialogs/DeleteSiteDialog";

export default {
    name: "Settings_Sites",
    components: {DeleteSiteDialog, CopySiteDialog, EditSiteDialog, AddSiteDialog, Button},
    data: () => ({
        ada,
        showSiteDialog: false,
        showEditSiteDialog: false,
        showCopySiteDialog: false,
        showDeleteSiteDialog: false,
        search_data: null,
        headers: [
            {text: 'ID', value: 'SiteId', width: '100px'},
            {text: 'Name', value: 'Name', width: '400px'},
            {text: 'Publisher', value: 'Publisher', width: '250px'},
            {text: 'Display', value: 'IsDisplay', width: '100px'},
            {text: 'Video', value: 'IsVideo', width: '100px'},
            {text: 'MoltenBundle', value: 'UsesAdaBundle'},
            {text: 'Aktion', value: 'action', width: '150px', sortable: false, align: 'center'},
        ]
    }),
    mounted() {
        this.init();
    },
    computed: {
        items() {
            let ret = this.$store.state.settings.sites || [];
            ret.forEach((item) => {
                item.Publisher = this.$store.state.display.publisher.find(x => x.PublisherId === item.PublisherId).Name;
                item.action = ['edit', 'copy', 'delete']
            })
            return ret;
        }
    },
    methods: {
        init() {
            if (this.$store.state.display.publisher === null) {
                this.$store.dispatch('display/fetchPublisher').then(() => {
                    this.$store.dispatch('settings/fetchAllSites')
                })
            } else {
                this.$store.dispatch('settings/fetchAllSites')
            }
        },
        async openDialog(data, type = 'edit') {
            this.$store.commit('settings/updateSelectedItem', data);
            if (type === 'edit') this.showEditSiteDialog = true;
            else if (type === 'add') this.showSiteDialog = true;
            else if (type === 'copy') this.showCopySiteDialog = true;
            else if (type === 'delete') this.showDeleteSiteDialog = true;

            if (data && type === 'edit') {
                await this.$store.dispatch('settings/fetchSiteDetails');
            } else if (this.$store.state.settings.selectedDetails) {
                this.$store.commit('settings/updateSelectedDetails', null);
            }
        },
        resetStore() {
            this.$store.commit('settings/updateSelectedItem', null);
            this.$store.commit('settings/updateSelectedDetails', null);
        },
        getAction(action) {
            let ret = {
                tooltip: '',
                icon: ''
            };
            if (action === 'edit') {
                ret.tooltip = 'Bearbeiten';
                ret.icon = 'mdi-pencil';
            } else if (action === 'delete') {
                ret.tooltip = 'Löschen';
                ret.icon = 'mdi-delete';
            } else if (action === 'copy') {
                ret.tooltip = 'Kopieren';
                ret.icon = 'mdi-content-copy';
            }
            return ret;
        }
    },
    watch: {
        showEditSiteDialog(newValue) {
            if (!newValue) {
                this.resetStore();
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.actionIcon {
    cursor: pointer;
    color: $ada_darkGrey !important;
    opacity: 0.6;
}

.actionIcon[data-type="edit"]:hover, .actionIcon[data-type="copy"]:hover, .actionIcon[data-type="json"]:hover {
    color: $ada_blue !important;
    opacity: 1;
}

.actionIcon[data-type="delete"]:hover {
    color: $ada_red !important;
    opacity: 1;
}

::v-deep tbody tr {
    cursor: pointer;
}

::v-deep .v-data-table__progress th {
    padding: 0 !important;
}

</style>